import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, computed } from "vue";
  import createJobStatusSetting from "@/types/requests/createJobStatusSetting"
  import createJobStatusFilterItems from "@/types/requests/createJobStatusFilterItems"
  import DownloadButton from "@/components/Files/DownloadButton"

  type Props = {
    showable: boolean;
    btnClass?: string;
    btnName?: string;
    type: string;
    operationOfficeId?: number;
    settings?: createJobStatusSetting;
    filterItems?: createJobStatusFilterItems;
    trips?: string[];
    disabled?: boolean;
    deliveryPlans?: Array<any>;
  };

  
export default /*@__PURE__*/_defineComponent({
  __name: 'DownloadButton',
  props: {
    showable: { type: Boolean, default: false },
    btnClass: {},
    btnName: {},
    type: {},
    operationOfficeId: {},
    settings: {},
    filterItems: {},
    trips: {},
    disabled: { type: Boolean, default: false },
    deliveryPlans: {}
  },
  setup(__props: any) {

  const props = __props;

  const getFilteredItems = () => {
    if (!props.deliveryPlans) return []

    const deliveryPlanIds = []
    props.deliveryPlans.forEach((v, i) => {
      deliveryPlanIds.push(v.delivery_plan_id)
    })
    return deliveryPlanIds
  }

  const addRequestParams = (params) => {
    if (!params.filter_items) params.filter_items = {}
    params.filter_items.delivery_plan_ids = getFilteredItems()
    return params
  }

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(_unref(DownloadButton), {
    class: _normalizeClass(props.btnClass),
    disabled: props.disabled,
    btnName: props.btnName,
    type: props.type,
    operationOfficeId: __props.operationOfficeId,
    settings: __props.settings,
    addRequestParams: addRequestParams
  }, null, 8, ["class", "disabled", "btnName", "type", "operationOfficeId", "settings"])), [
    [_vShow, props.showable]
  ])
}
}

})